module.exports = {"TXTWCL_Sorry___an_error_has_occurred":{"id":"TXTWCL_Sorry___an_error_has_occurred","defaultMessage":"Je nám líto, ale došlo k chybě."}}